<template>
  <bm-overlay
    ref="customOverlay"
    class="c_sample"
    :style="pointColor"
    pane="labelPane"
    @draw="draw">
    <div class="one flex_v flex_hc flex_vc" v-if="zoom <= 12">
      <h5>{{info.xzqhStr}}</h5>
      <p>{{info.itemCount}}个楼盘</p>
    </div>
    <div class="two flex_v flex_hc flex_vc" :class="check === info.itemId ? 'active' : ''" v-else>
      <p>{{info.tgmc}} | {{info.ksts}}套</p>
    </div>
  </bm-overlay>
</template>

<script>
import { BmOverlay } from 'vue-baidu-map-v3'
export default {
  props: ['info', 'position', 'check', 'zoom'], // 用来接受传入的值，用来定制样式
  components: {
    BmOverlay
  },
  watch: {
    position: {
      handler () {
        this.$refs.customOverlay.reload()  // 当位置发生变化时，重新渲染，内部会调用draw
      },
      deep: true
    },
  },
  data () {
    return {
      pointColor: ''
    }
  },
  mounted () {
    this.pointColor = this.color // 这里我是用来获取传入的值来定义样式的，可能有点多余了，pointColor是组件中绑定的样式，color是传进来的样式。【这样就可以根据传入的样式来显示不同样子的点了】
  },
  methods: {
    // 这是百度地图的重绘函数,用于维持覆盖物的位置（这里的值貌似会影响拖拉时的偏移度）
    draw ({ el, BMap, map }) {
      const { lng, lat } = this.position
      const pixel = map.pointToOverlayPixel(new BMap.Point(lng, lat))
      el.style.left = pixel.x - 16 + 'px'
      el.style.top = pixel.y - 16 + 'px'
    }
  }
}
</script>

<style lang="less">
.c_sample {
  position: absolute;
  .one{
    width: 1.6rem;
    height: 1.6rem;
    background-color: #2F72F5;
    border-radius: 50%;
    color: #fff;
    overflow: hidden;
    box-shadow: 0 0 0.05rem #000;
    color: #fff;
    text-align: center;
    h5{
      font-size: 0.28rem;
      margin-bottom: 0.06rem;
    }
    p{
      font-size: 0.24rem;
    }
  }
  .two{
    padding: 0.06rem 0.1rem;
    background-color: #2F72F5;
    border-radius: 0.08rem;
    color: #fff;
    overflow: hidden;
    box-shadow: 0 0 0.05rem #000;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    &.active{
      background-color: #db480e;
    }
    h5{
      font-size: 0.28rem;
      margin-bottom: 0.1rem;
    }
    p{
      font-size: 0.24rem;
    }
  }
}
</style>